(function () {
  'use strict';

  var state = {
    selectedTags: {}, // { 'Fuel-Type': ['Fuel-Type_Gas', ...], ... }
    collectionUrl: '',
    price: { min: null, max: null },
    sortBy: null
  };

  // ─── Boot ─────────────────────────────────────────────────────────────────

  function init() {
    var filterBar = document.querySelector('[data-filter-bar]');
    if (!filterBar) return;

    state.collectionUrl = filterBar.dataset.collectionUrl || '';

    var rawTags = filterBar.dataset.currentTags || '';
    var currentTags = rawTags ? rawTags.split('|').filter(Boolean) : [];

    // Prefixed tags (e.g. Fuel-Type_Gas) — category is the prefix
    currentTags.forEach(function (tag) {
      var parts = tag.split('_');
      if (parts.length < 2) return;
      var cat = parts[0];
      if (!state.selectedTags[cat]) state.selectedTags[cat] = [];
      if (state.selectedTags[cat].indexOf(tag) === -1) {
        state.selectedTags[cat].push(tag);
      }
    });

    // Plain tags (e.g. Gas) — find category from the rendered dropdown
    currentTags.forEach(function (tag) {
      if (tag.indexOf('_') !== -1) return;
      var matched = false;
      document.querySelectorAll('[data-filter-tag]').forEach(function (cb) {
        if (matched || cb.value !== tag) return;
        var dropdown = cb.closest('[data-filter-dropdown]');
        if (!dropdown || !dropdown.dataset.category) return;
        var cat = dropdown.dataset.category;
        if (!state.selectedTags[cat]) state.selectedTags[cat] = [];
        if (state.selectedTags[cat].indexOf(tag) === -1) {
          state.selectedTags[cat].push(tag);
        }
        matched = true;
      });
    });

    var params = new URLSearchParams(window.location.search);
    var pMin = params.get('filter.v.price.gte');
    var pMax = params.get('filter.v.price.lte');
    if (pMin) state.price.min = parseFloat(pMin);
    if (pMax) state.price.max = parseFloat(pMax);
    state.sortBy = params.get('sort_by');

    initDesktop(filterBar);
    initMobile();
    initPriceFilter();
    initSortDropdown(filterBar);
    hideOldSelectWidgets();
    fetchAndUpdateCounts();
    updateFilterBtnCount();
  }

  // ─── Sort dropdown ────────────────────────────────────────────────────────

  function initSortDropdown(filterBar) {
    var dropdown = filterBar.querySelector('[data-sort-dropdown]');
    if (!dropdown) return;

    var pill  = dropdown.querySelector('[data-sort-pill]');
    var panel = dropdown.querySelector('[data-sort-panel]');

    if (pill) {
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hidden;
        closeAllDropdowns(filterBar);
        closeSortDropdown(dropdown, pill, panel);
        if (!isOpen) {
          panel.hidden = false;
          pill.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('filter-dropdown--open');
        }
      });
    }

    dropdown.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sortValue = btn.dataset.sortValue;
        var sortName  = btn.textContent.trim();
        var label = dropdown.querySelector('[data-sort-label]');
        if (label) label.textContent = sortName;
        state.sortBy = sortValue;
        closeSortDropdown(dropdown, pill, panel);
        navigateToUrl(buildSortUrl(sortValue));
      });
    });

    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        closeSortDropdown(dropdown, pill, panel);
      }
    });
  }

  function closeSortDropdown(dropdown, pill, panel) {
    if (!panel) return;
    panel.hidden = true;
    if (pill) pill.setAttribute('aria-expanded', 'false');
    dropdown.classList.remove('filter-dropdown--open');
  }

  function buildSortUrl(sortValue) {
    var allTags = [];
    Object.keys(state.selectedTags).forEach(function (cat) {
      (state.selectedTags[cat] || []).forEach(function (tag) {
        if (allTags.indexOf(tag) === -1) allTags.push(tag);
      });
    });

    var base = allTags.length
      ? state.collectionUrl + '/' + allTags.map(tagToHandle).join('+')
      : state.collectionUrl;

    var queryParts = ['sort_by=' + encodeURIComponent(sortValue)];
    if (state.price.min !== null) queryParts.push('filter.v.price.gte=' + state.price.min);
    if (state.price.max !== null) queryParts.push('filter.v.price.lte=' + state.price.max);
    return base + '?' + queryParts.join('&');
  }

  function hideOldSelectWidgets() {
    var oldSort = document.querySelector('.filters-toolbar__item-child select[name="sort_by"]');
    if (oldSort) {
      var wrapper = oldSort.closest('.filters-toolbar__item-child');
      if (wrapper) wrapper.style.display = 'none';
    }
    var oldTags = document.querySelector('.filters-toolbar__item-child select[name="FilterTags"]');
    if (oldTags) {
      var tagsWrapper = oldTags.closest('.filters-toolbar__item-child');
      if (tagsWrapper) tagsWrapper.style.display = 'none';
    }
  }

  // ─── Desktop ──────────────────────────────────────────────────────────────

  function initDesktop(filterBar) {
    var dropdowns = filterBar.querySelectorAll('[data-filter-dropdown]');

    dropdowns.forEach(function (dropdown) {
      var pill      = dropdown.querySelector('[data-filter-pill]');
      var panel     = dropdown.querySelector('[data-filter-panel]');
      var clearBtn  = dropdown.querySelector('[data-filter-clear]');
      var checkboxes = dropdown.querySelectorAll('[data-filter-tag]');

      if (pill) {
        pill.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = !panel.hidden;
          closeAllDropdowns(filterBar);
          if (!isOpen) {
            panel.hidden = false;
            pill.setAttribute('aria-expanded', 'true');
            dropdown.classList.add('filter-dropdown--open');
          } else {
            navigateToUrl(buildUrl());
          }
        });
      }

      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var cat = dropdown.dataset.category;
          state.selectedTags[cat] = [];
          checkboxes.forEach(function (cb) { cb.checked = false; });
          updatePillState(dropdown, 0);
          updateCounter(dropdown, 0);
        });
      }

      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          var cat = dropdown.dataset.category;
          if (!cat) return;
          if (!state.selectedTags[cat]) state.selectedTags[cat] = [];

          if (checkbox.checked) {
            if (state.selectedTags[cat].indexOf(checkbox.value) === -1) {
              state.selectedTags[cat].push(checkbox.value);
            }
          } else {
            state.selectedTags[cat] = state.selectedTags[cat].filter(function (t) {
              return t !== checkbox.value;
            });
          }

          var count = state.selectedTags[cat].length;
          updateCounter(dropdown, count);
          updatePillState(dropdown, count);
          navigateToUrl(buildUrl());
        });
      });
    });

    initActiveRow(filterBar);

    // Apply on outside click
    document.addEventListener('click', function (e) {
      if (filterBar.contains(e.target)) return;
      var anyOpen = filterBar.querySelector('[data-filter-panel]:not([hidden])');
      if (anyOpen) {
        closeAllDropdowns(filterBar);
        navigateToUrl(buildUrl());
      }
    });
  }

  function closeAllDropdowns(filterBar) {
    filterBar.querySelectorAll('[data-filter-dropdown]').forEach(function (dd) {
      var panel = dd.querySelector('[data-filter-panel]');
      var pill  = dd.querySelector('[data-filter-pill]');
      if (panel) panel.hidden = true;
      if (pill)  pill.setAttribute('aria-expanded', 'false');
      dd.classList.remove('filter-dropdown--open');
    });
  }

  function updateCounter(dropdown, count) {
    var el = dropdown.querySelector('[data-selected-count]');
    if (!el) return;
    if (count === 0) {
      el.textContent = '';
      el.hidden = true;
    } else {
      el.textContent = count + ' selected';
      el.hidden = false;
    }
  }

  function updatePillState(dropdown, count) {
    var pill = dropdown.querySelector('[data-filter-pill]');
    if (!pill) return;
    if (count > 0) {
      pill.classList.add('filter-dropdown__pill--active');
    } else {
      pill.classList.remove('filter-dropdown__pill--active');
    }
  }

  function initActiveRow(filterBar) {
    var row = filterBar.querySelector('[data-active-filters-row]');

    // Create the row if price is active but no tag filters (Liquid skips rendering it)
    if (!row && (state.price.min !== null || state.price.max !== null)) {
      row = document.createElement('div');
      row.className = 'filter-bar__active-row';
      row.setAttribute('data-active-filters-row', '');
      row.innerHTML = '<div class="filter-bar__active-inner">' +
        '<button class="filter-bar__clear-all" type="button" data-active-clear-all>Clear All</button>' +
        '</div>';
      var barInner = filterBar.querySelector('.filter-bar__inner');
      if (barInner) barInner.insertAdjacentElement('afterend', row);
      else filterBar.appendChild(row);
    }

    if (!row) return;

    row.querySelectorAll('[data-active-chip]').forEach(function (chip) {
      var removeBtn = chip.querySelector('[data-chip-remove]');
      if (!removeBtn) return;
      removeBtn.addEventListener('click', function () {
        var tag = chip.dataset.tag;
        var cat = chip.dataset.cat;
        if (state.selectedTags[cat]) {
          state.selectedTags[cat] = state.selectedTags[cat].filter(function (t) { return t !== tag; });
        }
        navigateToUrl(buildUrl());
      });
    });

    // Price chip
    if (state.price.min !== null || state.price.max !== null) {
      var inner = row.querySelector('.filter-bar__active-inner');
      if (inner) {
        var label = state.price.min !== null && state.price.max !== null
          ? '$' + state.price.min + ' – $' + state.price.max
          : state.price.min !== null ? 'From $' + state.price.min
          : 'Up to $' + state.price.max;
        var priceChip = document.createElement('div');
        priceChip.className = 'filter-chip';
        priceChip.innerHTML = '<span class="filter-chip__label">' + label + '</span>' +
          '<button class="filter-chip__remove" type="button" data-price-chip-remove aria-label="Remove price filter">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
          '<path d="M2 2L12 12M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg></button>';
        var clearBtn = inner.querySelector('[data-active-clear-all]');
        inner.insertBefore(priceChip, clearBtn);
        priceChip.querySelector('[data-price-chip-remove]').addEventListener('click', function () {
          state.price.min = null;
          state.price.max = null;
          navigateToUrl(buildUrl());
        });
      }
    }

    var clearAllBtn = row.querySelector('[data-active-clear-all]');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        state.selectedTags = {};
        state.price.min = null;
        state.price.max = null;
        navigateToUrl(buildUrl());
      });
    }
  }

  // ─── Mobile ───────────────────────────────────────────────────────────────

  function initMobile() {
    var openBtn  = document.querySelector('[data-filter-mobile-open]');
    var drawer   = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;

    var closeBtn   = drawer.querySelector('[data-filter-drawer-close]');
    var applyBtn   = drawer.querySelector('[data-filter-apply]');
    var clearAll   = drawer.querySelector('[data-filter-clear-all]');
    var chipsEl    = drawer.querySelector('[data-filter-chips]');
    var accordions = drawer.querySelectorAll('[data-accordion-section]');

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        openDrawer(drawer);
      });
    }

    attachChipListeners(chipsEl, drawer);

    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeDrawer(drawer); });
    }

    if (applyBtn) {
      applyBtn.addEventListener('click', function () { navigateToUrl(buildUrl()); });
    }

    if (clearAll) {
      clearAll.addEventListener('click', function () {
        state.selectedTags = {};
        drawer.querySelectorAll('[data-filter-tag]').forEach(function (cb) { cb.checked = false; });
        renderChips(chipsEl, drawer);
      });
    }

    accordions.forEach(function (section) {
      var toggle = section.querySelector('[data-accordion-toggle]');
      var panel  = section.querySelector('[data-accordion-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = section.classList.contains('filter-accordion--open');
        section.classList.toggle('filter-accordion--open', !isOpen);
        panel.hidden = isOpen;
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    drawer.querySelectorAll('[data-filter-tag]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var section = checkbox.closest('[data-accordion-section]');
        var cat = section ? section.dataset.category : null;
        if (!cat) return;

        if (!state.selectedTags[cat]) state.selectedTags[cat] = [];

        if (checkbox.checked) {
          if (state.selectedTags[cat].indexOf(checkbox.value) === -1) {
            state.selectedTags[cat].push(checkbox.value);
          }
        } else {
          state.selectedTags[cat] = state.selectedTags[cat].filter(function (t) {
            return t !== checkbox.value;
          });
        }

        renderChips(chipsEl, drawer);
      });
    });

    drawer.querySelectorAll('[data-sort-mobile]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) state.sortBy = radio.value;
      });
    });

    // Close on backdrop click
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer(drawer);
    });
  }

  function openDrawer(drawer) {
    drawer.classList.add('filter-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('filter-drawer--open');
    document.body.style.overflow = '';
  }

  function attachChipListeners(container, drawer) {
    if (!container) return;
    container.querySelectorAll('[data-chip-tag]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.chipTag;
        var cat = btn.dataset.chipCat;
        if (state.selectedTags[cat]) {
          state.selectedTags[cat] = state.selectedTags[cat].filter(function (t) { return t !== tag; });
        }
        renderChips(container, drawer);
        navigateToUrl(buildUrl());
      });
    });
  }

  function renderChips(container, drawer) {
    if (!container) return;
    container.innerHTML = '';

    Object.keys(state.selectedTags).forEach(function (cat) {
      (state.selectedTags[cat] || []).forEach(function (tag) {
        var label = tag.indexOf('_') !== -1
          ? tag.split('_').slice(1).join('_').replace(/-/g, ' ')
          : tag;

        var labelEl = document.createElement('span');
        labelEl.className = 'filter-chip__label';
        labelEl.textContent = label;

        var removeBtn = document.createElement('button');
        removeBtn.className = 'filter-chip__remove';
        removeBtn.type = 'button';
        removeBtn.dataset.chipTag = tag;
        removeBtn.dataset.chipCat = cat;
        removeBtn.setAttribute('aria-label', 'Remove ' + label + ' filter');
        removeBtn.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

        var chip = document.createElement('div');
        chip.className = 'filter-chip';
        chip.appendChild(labelEl);
        chip.appendChild(removeBtn);
        container.appendChild(chip);
      });
    });

    attachChipListeners(container, drawer);
  }

  // ─── Price filter ─────────────────────────────────────────────────────────

  function initPriceFilter() {
    document.querySelectorAll('[data-price-min-input]').forEach(function (input) {
      if (state.price.min !== null) input.value = state.price.min;
      input.addEventListener('input', function () {
        state.price.min = input.value !== '' ? parseFloat(input.value) : null;
        if (input.hasAttribute('data-price-desktop')) updatePricePillState();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.hasAttribute('data-price-desktop')) {
          e.preventDefault();
          navigateWithPrice();
        }
      });
    });

    document.querySelectorAll('[data-price-max-input]').forEach(function (input) {
      if (state.price.max !== null) input.value = state.price.max;
      input.addEventListener('input', function () {
        state.price.max = input.value !== '' ? parseFloat(input.value) : null;
        if (input.hasAttribute('data-price-desktop')) updatePricePillState();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.hasAttribute('data-price-desktop')) {
          e.preventDefault();
          navigateWithPrice();
        }
      });
    });

    document.querySelectorAll('[data-price-apply-desktop]').forEach(function (btn) {
      btn.addEventListener('click', function () { navigateWithPrice(); });
    });

    document.querySelectorAll('[data-price-clear-desktop]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        state.price.min = null;
        state.price.max = null;
        document.querySelectorAll('[data-price-min-input]').forEach(function (i) { i.value = ''; });
        document.querySelectorAll('[data-price-max-input]').forEach(function (i) { i.value = ''; });
        updatePricePillState();
      });
    });

    updatePricePillState();
  }

  function navigateWithPrice() {
    var filterBar = document.querySelector('[data-filter-bar]');
    if (filterBar) closeAllDropdowns(filterBar);
    navigateToUrl(buildUrl());
  }

  function updatePricePillState() {
    var dropdown = document.querySelector('[data-filter-price-dropdown]');
    if (!dropdown) return;
    var isActive = state.price.min !== null || state.price.max !== null;
    var pill = dropdown.querySelector('[data-filter-pill]');
    if (pill) pill.classList.toggle('filter-dropdown__pill--active', isActive);
    dropdown.classList.toggle('filter-dropdown--active', isActive);
  }

  // ─── Counts ───────────────────────────────────────────────────────────────

  function fetchAndUpdateCounts() {
    if (!state.collectionUrl) return;
    fetch(state.collectionUrl + '/products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var counts = {};
        var priceMin = Infinity, priceMax = 0;
        (data.products || []).forEach(function (product) {
          (product.tags || []).forEach(function (tag) {
            counts[tag] = (counts[tag] || 0) + 1;
          });
          (product.variants || []).forEach(function (v) {
            var p = parseFloat(v.price || 0);
            if (p < priceMin) priceMin = p;
            if (p > priceMax) priceMax = p;
          });
        });
        document.querySelectorAll('[data-option-count]').forEach(function (el) {
          var tag = el.dataset.optionCount;
          var n = counts[tag] || 0;
          el.textContent = n > 0 ? '(' + n + ')' : '';

          var item = el.closest('li');
          if (item) {
            var checkbox = item.querySelector('[data-filter-tag]');
            var isSelected = checkbox && checkbox.checked;
            item.hidden = n === 0 && !isSelected;
          }
        });
        if (priceMin !== Infinity) {
          var floorMin = Math.floor(priceMin);
          var ceilMax  = Math.ceil(priceMax);
          document.querySelectorAll('[data-price-min-input]').forEach(function (i) {
            i.setAttribute('min', floorMin);
            if (i.getAttribute('placeholder') === 'Min') i.setAttribute('placeholder', floorMin);
          });
          document.querySelectorAll('[data-price-max-input]').forEach(function (i) {
            i.setAttribute('max', ceilMax);
            if (i.getAttribute('placeholder') === 'Max') i.setAttribute('placeholder', ceilMax);
          });
        }
      })
      .catch(function () {});
  }

  function updateFilterBtnCount() {
    var btn = document.querySelector('[data-filter-mobile-open]');
    if (!btn) return;
    var total = 0;
    Object.keys(state.selectedTags).forEach(function (cat) {
      total += (state.selectedTags[cat] || []).length;
    });
    var countEl = btn.querySelector('[data-filter-btn-count]');
    if (!countEl) {
      countEl = document.createElement('span');
      countEl.setAttribute('data-filter-btn-count', '');
      btn.appendChild(countEl);
    }
    countEl.textContent = total > 0 ? ' (' + total + ')' : '';
  }

  // ─── URL ──────────────────────────────────────────────────────────────────

  function tagToHandle(tag) {
    return tag
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildUrl() {
    var allTags = [];
    Object.keys(state.selectedTags).forEach(function (cat) {
      (state.selectedTags[cat] || []).forEach(function (tag) {
        if (allTags.indexOf(tag) === -1) allTags.push(tag);
      });
    });

    var base = allTags.length
      ? state.collectionUrl + '/' + allTags.map(tagToHandle).join('+')
      : state.collectionUrl;

    var queryParts = [];
    if (state.sortBy) queryParts.push('sort_by=' + encodeURIComponent(state.sortBy));
    if (state.price.min !== null) queryParts.push('filter.v.price.gte=' + state.price.min);
    if (state.price.max !== null) queryParts.push('filter.v.price.lte=' + state.price.max);
    if (queryParts.length) base += '?' + queryParts.join('&');

    return base;
  }

  function navigateToUrl(url) {
    var currentFull = window.location.pathname + window.location.search;
    var normalize = function (u) { return u.replace(/\/$/, ''); };
    if (normalize(url) === normalize(currentFull)) return;
    window.location.href = url;
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();